import {stage} from '@/constant/env';

let locales = [];
if (stage === 'prod') {
  locales = [
    {
      code: 'zh-TW',
      name: '繁體中文',
    },
    {
      code: 'zh-CN',
      name: '简体中文',
    },
    {
      code: 'ja-JP',
      name: '日本語',
    },
    {
      code: 'en-US',
      name: 'English',
    },
  ];
} else {
  locales = [
    {
      code: 'zh-TW',
      name: '繁體中文',
    },
    {
      code: 'zh-CN',
      name: '简体中文',
    },
    {
      code: 'ja-JP',
      name: '日本語',
    },
    {
      code: 'en-US',
      name: 'English',
    },
  ];
}

export default locales;
